import { render, staticRenderFns } from "./typelist.vue?vue&type=template&id=22d7a900&scoped=true&"
import script from "./typelist.vue?vue&type=script&lang=js&"
export * from "./typelist.vue?vue&type=script&lang=js&"
import style0 from "./typelist.vue?vue&type=style&index=0&id=22d7a900&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7a900",
  null
  
)

export default component.exports